<script setup>
import { computed } from 'vue';
import { useAuthStore } from './stores/auth';
import { useRouter } from 'vue-router';
import AppNavbar from './components/AppNavbar.vue';

const auth = useAuthStore();
const router = useRouter();

const showNavbar = computed(() => {
  return router.currentRoute.value.name !== 'login';
});
</script>

<template>
  <div class="min-h-screen bg-slate-50 dark:bg-slate-900">
    <AppNavbar v-if="showNavbar" />

    <main :class="{ 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8': showNavbar }">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>

    <footer v-if="showNavbar" class="mt-auto py-6 text-center text-slate-500 text-sm">
      &copy; 2024 IanKing Tailoring System | Developed by KWD
    </footer>
  </div>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
